let $ = jQuery;
let Hammer = require('hammerjs');
let breakpoints = require('../utilities/breakpoints');

let carouselClass = '.js-gallery-carousel';

class GalleryCarousel {

  constructor($carousel) {
    this.$carousel = $($carousel);
    this.nodeId = this.$carousel.data('id');
    this.carouselData;

    this.$content;
    this.$carouselItems;
    this.$nav;
    this.$navBtns;
    this.$prevBtn;
    this.$nextBtn;
    this.$navIndex;
    this.currentItem = 0;
    this.totalItems;
    this.isAdvancing = false;
    this.animLength = 250; // .25s in css transition.

    this.loadGallery();
  }

  loadGallery() {
    $.getJSON("/api/v1/gallery/" + this.nodeId, (data) => {
      if (data.length < 1) {

        this.generateErrorMsg();
        return false;
      }

      this.carouselData = data;
      this.totalItems = this.carouselData.length;
      this.buildCarousel();
    })
    .error(() => this.generateErrorMsg());
  }

  buildCarousel() {
    var carousel = this.getCarouselMarkup();
    var nav = this.getNavMarkup();
    this.$carousel.html(carousel);
    this.$carousel.append(nav);

    this.bind();
    this.styleCarouselItems();
    this.$carousel.addClass('loaded');

    this.setActiveItem();
    this.setBtnStates();
  }

  bind() {
    // Save jquery objects.
    this.$content = this.$carousel.children("div");
    this.$carouselItems = this.$content.children();
    this.$nav = this.$carousel.find("nav");
    this.$navBtns = this.$nav.find("button");
    this.$prevBtn = this.$nav.find("[data-direction='previous']");
    this.$nextBtn = this.$nav.find("[data-direction='next']");
    this.$navIndex = this.$nav.find("p");

    // Swipe Events.
    let content = this.$content[0];
    let hammer = new Hammer(content);
    hammer.on('swipeleft', (e) => this.advanceCarousel("next"));
    hammer.on('swiperight', (e) => this.advanceCarousel("previous"));

    // Click Events.
    this.$navBtns.off("click.carouselNav").on("click.carouselNav", (e) => this.handleClick(e));
  }

  getCarouselMarkup() {

    // Create wrapper.
    var content = document.createElement("div");
        content.className = "photo-gallery__items";

    // Loop through objects in data array.
    $.each(this.carouselData, (index) => {
      var itemData = this.carouselData[index];
      var item = this.getCarouselItemMarkup(itemData);

      content.appendChild(item);
    });

    return content;
  }

  getCarouselItemMarkup(itemData) {
    var itemMarkup = document.createElement("div");
        itemMarkup.className = "photo-gallery__item";

    var imgWrapper = document.createElement("div");
        imgWrapper.className = "photo-gallery__img-wrap";
        imgWrapper.innerHTML = itemData["field_image"];

    var citation = document.createElement("p");
    var caption = document.createElement("p");
        citation.innerHTML = itemData["field_credit"];
        caption.innerHTML = itemData["field_caption"];

    var captionWrapper = document.createElement("div");
        captionWrapper.className = "photo-gallery__img-caption";
        captionWrapper.appendChild(citation);
        captionWrapper.appendChild(caption);

    itemMarkup.appendChild(imgWrapper);
    itemMarkup.appendChild(captionWrapper);

    return itemMarkup;
  }

  getNavMarkup() {
    var nav = document.createElement("nav");
        nav.className = "photo-gallery__nav";

    var prevBtn = document.createElement("button");
        prevBtn.setAttribute("data-direction", "previous");
    var nextBtn = document.createElement("button");
        nextBtn.setAttribute("data-direction", "next");

    var pagination = document.createElement("p");
        pagination.className = "photo-gallery__loc";

    var current = document.createElement("span");
        current.className = "loc-index";
        current.innerHTML = this.currentItem + 1;

    var total = document.createElement("span");
        total.className = "loc-total";
        total.innerHTML = this.totalItems;

    pagination.appendChild(current);
    pagination.innerHTML = pagination.innerHTML + " of ";
    pagination.appendChild(total);

    nav.appendChild(prevBtn);
    nav.appendChild(pagination);
    nav.appendChild(nextBtn);

    return nav;
  }

  generateErrorMsg() {
    console.log('there has been an error or this gallery contains no images.');
  }

  handleClick(e) {
    var $target = $(e.currentTarget);

    this.advanceCarousel($target.data('direction'));

    return false;
  }

  advanceCarousel(direction) {
    if (this.isAdvancing || !direction) {
      return false;
    }

    this.isAdvancing = true;

    if (direction === "previous" && !this.$prevBtn.hasClass('disabled')) {
      // set offset
      this.currentItem--;
    }
    else if (direction === "next" && !this.$nextBtn.hasClass('disabled')) {
      // set offset
      this.currentItem++;
    }

    this.setIndex();
    this.setActiveItem();
    this.setTransform();
    this.setBtnStates();

    // Pause before toggling boolean value, to stay in sync with css transition.
    window.setTimeout(() => {
      this.isAdvancing = false;
    }, this.animLength);

  }

  // setupDom() {
  //   this.labelBtns();
  //   this.setupCarouselItems();
  //   this.setIndex();
  //   this.setTransform();
  //   this.setBtnStates();
  //
  //   this.$carousel.addClass('loaded');
  //   this.setActiveItem();
  // }

  setTransform() {
    this.$content.css('left', "-" + this.currentItem + "00%");
  }

  setIndex() {
    this.$navIndex.find('.loc-index').html(this.currentItem + 1);
    this.$navIndex.find('.loc-total').html(this.totalItems);
  }

  setActiveItem() {
    $.each(this.$carouselItems, (index, elem) => {
      var $item = $(elem);

      if (index === this.currentItem) {
        $item.addClass('active');
      }
      else {
        $item.removeClass('active');
      }
    });
  }

  setBtnStates() {

    if (this.currentItem < 1) {
      this.$prevBtn.addClass('disabled');
    }
    else {
      this.$prevBtn.removeClass('disabled');
    }

    if (this.currentItem >= this.totalItems - 1) {
      this.$nextBtn.addClass('disabled');
    }
    else {
      this.$nextBtn.removeClass('disabled');
    }
  }

  styleCarouselItems() {
    // Set content area width.
    this.$content.css({
      'width': this.totalItems + '00%'
    });

    this.$content.children().css({
      'width': 100 / this.totalItems + '%',
      'display': 'block',
      'float': 'left'
    });
  }

  labelBtns() {
    // Get rid of the buttons, if for some reason there's only one item.
    if (this.totalItems < 1) {
      this.$nav.remove();

      return false;
    }

    $.each(this.$navBtns, (index, elem) => {
      var dataDir = "previous";

      if (index === 0) {
        this.$prevBtn = $(elem);
      }
      else if (index === 1) {
        this.$nextBtn = $(elem);
        dataDir = "next";
      }

      $(elem).data("direction", dataDir);

    });
  }
}

function init() {

  if($(carouselClass).length) {

    $.each($(carouselClass), (index, elem) => {
      let galleryCarousel = new GalleryCarousel(elem);
    });
  }
}

if(typeof Drupal === "undefined") {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function(context, settings) {
      init();
    }
  }
}
